import lottieWeb from "lottie-web";
window.onload = () => {
    const playIconContainer = document.getElementById("play-icon");
    const prevIconContainer = document.getElementById("prev-icon");
    const nextIconContainer = document.getElementById("next-icon");
    const shuffleIconContainer = document.getElementById("shuffle-icon");
    const audioPlayerContainer = document.getElementById(
        "music-player-container"
    );
    const seekSlider = document.getElementById("seek-slider");
    const volumeSlider = document.getElementById("volume-slider");
    const muteIconContainer = document.getElementById("mute-icon");
    const audio = document.getElementById("track-audio");
    const durationContainer = document.getElementById("duration");
    const currentTimeContainer = document.getElementById("current-time");
    let playState = "play"; 
    let muteState = "unmute";
    // let track_index = 0;

    const playAnimation = lottieWeb.loadAnimation({
        container: playIconContainer,
        path: "https://maxst.icons8.com/vue-static/landings/animated-icons/icons/pause/pause.json",
        renderer: "svg",
        loop: false,
        autoplay: false,
        name: "Play Animation"
    });

    const prevAnimation = lottieWeb.loadAnimation({
        container: prevIconContainer,
        path: "https://maxst.icons8.com/vue-static/landings/animated-icons/icons/skip-backwards/skip-backwards.json",
        renderer: "svg",
        loop: false,
        autoplay: false,
        name: "Prev Animation"
    });

    const nextAnimation = lottieWeb.loadAnimation({
        container: nextIconContainer,
        path: "https://maxst.icons8.com/vue-static/landings/animated-icons/icons/skip-forwards/skip-forwards.json",
        renderer: "svg",
        loop: false,
        autoplay: false,
        name: "Next Animation"
    });

    const muteAnimation = lottieWeb.loadAnimation({
        container: muteIconContainer,
        path: "https://maxst.icons8.com/vue-static/landings/animated-icons/icons/mute/mute.json",
        renderer: "svg",
        loop: false,
        autoplay: false,
        name: "Mute Animation"
    });

    playAnimation.goToAndStop(14, true);

    // On click play/pause button
    if (playIconContainer != null) {
        playIconContainer.addEventListener("click", () => {
            if (playState === "play") {
                playAnimation.playSegments([14, 27], true);
                playState = "pause";
                audio.play();
            } else {
                playAnimation.playSegments([0, 14], true);
                playState = "play";
                audio.pause();
            }
        });
    }
    // Get all number song playlist
    

    if ($('#shuffle-icon').length > 0) {
        let shuffle = $('#shuffle-icon path').attr('data-shuffle');
        if (shuffle == 1) {
            $('#shuffle-icon path').addClass('shuffle');
        }
    }

    // On click shuffle button

    if (shuffleIconContainer != null) {
        shuffleIconContainer.addEventListener("click", () => {
            let shuffle = $('#shuffle-icon path').attr('data-shuffle');
            if (shuffle == 0) {
                $('#shuffle-icon path').addClass('shuffle');
                shuffle = 1;
                $('#shuffle-icon path').attr('data-shuffle', shuffle)
            } else {
                $('#shuffle-icon path').removeClass('shuffle');
                shuffle = 0;
                $('#shuffle-icon path').attr('data-shuffle', shuffle)
            }
            $.cookie('shuffle', shuffle, {
                expires: 1,
                path: '/'
            });
        });
    }

    var nextTrack = function () {
        if($('.section-list-song .list-song').find('.playlist__song.active')){
            let _this = $('.section-list-song .list-song').find('.playlist__song.active');
            let id = $('.section-list-song .list-song').find('.playlist__song.active').attr('data-number');
            let idFirst = $('.section-list-song .list-song .playlist__song:first-child').attr('data-number');
            let idLast = $('.section-list-song .list-song .playlist__song:last-child').attr('data-number');
            let url = $('.section-list-song .list-song .playlist__song[data-number='+(parseInt(id)+1)+']').attr('data-url');
            let urlFirst = $('.section-list-song .list-song .playlist__song:first-child').attr('data-url');

            let register = _this.attr('data-register');
            let is4g = _this.attr('data-is4g');
            if(register == 0 || !is4g){
                if (id != idLast) {
                    audio.src = url;
                    $('.section-list-song .list-song .playlist__song').removeClass('active');
                    $('.section-list-song .list-song .playlist__song[data-number='+(parseInt(id)+1)+']').addClass('active');
                }
                if (id == idLast) {
                    audio.src = urlFirst;
                    $('.section-list-song .list-song .playlist__song').removeClass('active');
                    $('.section-list-song .list-song .playlist__song[data-number='+(idFirst)+']').addClass('active');
                }
            }else{
                $('.modal-reg-package-music').modal('show');
            }

        }
    };

    var prevTrack = function () {
        if($('.section-list-song .list-song').find('.playlist__song.active')){
            let id = $('.section-list-song .list-song').find('.playlist__song.active').attr('data-number');
            let idFirst = $('.section-list-song .list-song .playlist__song:first-child').attr('data-number');
            let idLast = $('.section-list-song .list-song .playlist__song:last-child').attr('data-number');
            let url = $('.section-list-song .list-song .playlist__song[data-number='+(parseInt(id)-1)+']').attr('data-url');
            let urlLast = $('.section-list-song .list-song .playlist__song:last-child').attr('data-url');
            if (id != idFirst) {
                audio.src = url;
                $('.section-list-song .list-song .playlist__song').removeClass('active');
                $('.section-list-song .list-song .playlist__song[data-number='+(parseInt(id)-1)+']').addClass('active');
            }
            if (id == idFirst) {
                audio.src = urlLast;
                $('.section-list-song .list-song .playlist__song').removeClass('active');
                $('.section-list-song .list-song .playlist__song[data-number='+(idLast)+']').addClass('active');
            }
        }
    }

    // On click previous track button
    if (prevIconContainer != null) {
        prevIconContainer.addEventListener("click", () => {
            prevTrack();
            prevAnimation.stop();
            prevAnimation.play();
        });
    }

    // On click next track button
    if (nextIconContainer != null) {
        nextIconContainer.addEventListener("click", () => {
            nextTrack();
            nextAnimation.stop();
            nextAnimation.play();
        });
    }


    // On click mute/unmute track button
    if (muteIconContainer != null) {
        muteIconContainer.addEventListener("click", () => {
            if (muteState === "unmute") {
                muteAnimation.playSegments([0, 15], true);
                muteState = "mute";
                audio.volume = 0;
            } else {
                muteAnimation.playSegments([15, 25], true);
                muteState = "unmute";
                audio.volume = 0.99;
            }
        });
    }

    const showRangeProgress = rangeInput => {
        if (rangeInput === seekSlider) {
            audioPlayerContainer.style.setProperty(
                "--seek-before-width",
                (rangeInput.value / rangeInput.max) * 100 + "%"
            );
        } else {
            audioPlayerContainer.style.setProperty(
                "--volume-before-width",
                (rangeInput.value / rangeInput.max) * 100 + "%"
            );
        }
    };

    // On drag the audio track seeker
    if (seekSlider != null) {
        seekSlider.addEventListener("input", e => {
            seekSlider.value = e.target.value;
            audio.currentTime = Number(e.target.value);
            showRangeProgress(e.target);
        });
        seekSlider.addEventListener("mousedown", () => {
            audio.pause();
        });

        seekSlider.addEventListener("mouseup", () => {
            audio.play();
        });
    }



    // On drag the audio volume seeker
    if (volumeSlider != null) {
        volumeSlider.addEventListener("input", e => {
            audio.volume = e.target.value / 100;
            showRangeProgress(e.target);
        });
    }

    // Audio logic

    // Load the audio


    // Play the audio when it's ready
    if (audio != null) {
        audio.load();
        audio.addEventListener("canplay", event => {
            setTimeout(() => {
                audio.play();
                playAnimation.playSegments([14, 27], true);
                playState = "pause";
            }, 400);
        });
        audio.addEventListener("playing", event => {});

    }


    // Change the state of player to playing


    const calculateTime = secs => {
        const minutes = Math.floor(secs / 60);
        const seconds = Math.floor(secs % 60);
        const returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
        return `${minutes}:${returnedSeconds}`;
    };

    const displayDuration = () => {
        durationContainer.textContent = calculateTime(audio.duration);
    };

    const setSliderMax = () => {
        seekSlider.max = Math.floor(audio.duration);
    };

    const displayBufferedAmount = () => {
        const bufferedAmount = Math.floor(
            audio.buffered.end(audio.buffered - 1)
        );
        audioPlayerContainer.style.setProperty(
            "--buffered-width",
            `${(bufferedAmount / seekSlider.max) * 100}%`
        );
    };
    
    if (audio != null) {
        const updateSeeker = () => {
            let shuffle = $('#shuffle-icon path').attr('data-shuffle');
            let audios = [];
            seekSlider.value = audio.currentTime;
            currentTimeContainer.textContent = calculateTime(audio.currentTime);
            if (!isNaN(audio.duration)) {
                durationContainer.textContent = calculateTime(audio.duration);
                if (currentTimeContainer.textContent === durationContainer.textContent && shuffle == 1) {
                    $(".playlist__song").each(function () {
                        let number = $(this).attr("data-number");
                        audios.push(number);
                    });
                    let randomIndex = Math.floor(Math.random() * audios.length);
                    let url = $('.section-list-song .list-song .playlist__song[data-number='+(parseInt(randomIndex))+']').attr('data-url');
                    audio.src = url;
                    $('.section-list-song .list-song .playlist__song').removeClass('active');
                    $('.section-list-song .list-song .playlist__song[data-number='+(parseInt(randomIndex))+']').addClass('active');
                    let position = $('.playlist__song.active').position();
                    $('.section-list-song .list-song').scrollTop(position.top);
                }
                if (currentTimeContainer.textContent === durationContainer.textContent && shuffle != 1) {
                    nextTrack();
                }
            }
            audioPlayerContainer.style.setProperty(
                "--seek-before-width",
                `${(audio.currentTime / audio.duration) * 100}%`
            );
        };

        if (audio.readyState > 0) {
            displayDuration();
            setSliderMax();
            displayBufferedAmount();
        } else {
            audio.addEventListener("loadedmetadata", () => {
                displayDuration();
                setSliderMax();
                displayBufferedAmount();
            });
        }
        audio.addEventListener("progress", displayBufferedAmount);
        audio.addEventListener("timeupdate", updateSeeker);
    }
};
